export const footer = {
    newsletter: {
        label: 'Newsletter signup',
        inputLabels: {
            email: 'Email',
            next: 'Next',
            salutation: 'Salutation',
            firstname: 'First name',
            lastname: 'Last name',
            company: 'Company',
            address: 'Address',
            postalCode: 'Postal code',
            city: 'City',
            privacyStatement: 'Privacy statement',
            privacyStatementCheckbox:
                'I agree with Murtfeldt Additive Solutions processing my personal data in order to fulfill my request. ',
            send: 'Absenden',
        },
        requiredFieldsMissing: 'Some required fields are missing',
    },
    socialMedia: {
        label: 'Follow us on',
    },
    legal: {
        label: 'Legal',
    },
    navigation: {
        reportBug: 'Report bug',
    },
};
